import { Link } from "react-router-dom";

const HIGHLIGHTS = [
  { icon: "ri-stack-line", title: "资源聚合", desc: "电影与电视剧统一收录，类型齐全" },
  { icon: "ri-filter-3-line", title: "分类清晰", desc: "类型、年份、地区多维筛选与排序" },
  { icon: "ri-heart-3-line", title: "一键收藏", desc: "本地保存喜爱的影视，随时回看" },
  { icon: "ri-device-line", title: "多端适配", desc: "电脑与手机端同样流畅易用" },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-900/60 py-10 md:py-14" aria-label="网站简介">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-3 py-1 text-sm font-medium text-accent-400">
              <i className="ri-information-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-foreground-50 md:text-4xl">
              免费播放片大片
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
              免费播放片大片是一个聚合最新、最全影视资源的综合内容平台，面向喜欢在线观看热门电影、经典电视剧与新鲜剧集
              的普通用户、影视迷与影评爱好者。我们致力于用清晰的信息结构与便捷的浏览方式，帮助你快速找到并了解感兴趣
              的影视作品。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              本站为演示性质站点，所有影视名称、简介与图片均为虚构示例数据，不提供真实在线播放服务。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 rounded-md border border-background-600 px-5 py-2.5 text-sm font-medium text-foreground-100 whitespace-nowrap transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {HIGHLIGHTS.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-800 bg-background-950/60 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-accent-400">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-50">{item.title}</h3>
                <p className="mt-1 text-sm text-foreground-400">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}